module.exports = __webpack_public_path__ + "media/images/apple-icon-72x72-95963d85e75ba4f6d847aabb7053e0c3.png";